 <template>
  <div class="slider-container">
    <v-slider
      max="1"
      min="0"
      step=".01"
      append-icon="mdi-opacity"
      prepend-icon="mdi-opacity"
      v-model="opacitySlideValue"
    >
    </v-slider>
  </div>
</template>
    <script>
export default {
  name: "OpacitySlider",
  data: function () {
    return {};
  },
  computed: {
    opacitySlideValue: {
      get: function () {
        return this.$store.getters.getOpacitySlideValue;
      },
      set: function (newValue) {
        this.$store.commit("setOpacitySlideValue", newValue);
      },

    },
  },
  methods:{
    
  }
};
</script>
    <style scoped>
.v-input {
  z-index: 1;
  right: 0;
  width: 100%;
  background: #ffffff9e;
}

.slider-label-container {
  right: 0;
  color: black;
  z-index: 1;
  padding: 0 2%;
  margin-top: 3%;
  width: 100%;
}

.slider-label-left {
  float: left;
}
.slider-label-right {
  float: right;
}

.slider-container{
    height: 33px;
}


</style>
<style>
.v-input__append-outer .mdi-opacity.v-icon.v-icon {
  color: black;
}

.v-input__prepend-outer .mdi-opacity.v-icon.v-icon {
  color: lightgray;
}

.slider-container .v-slider{
    cursor:pointer !important;
}
</style>